/**
 * Entrada de CSS da área autenticada React (shell + login + módulos).
 * Carregada via `useLegadoVisual()` (?inline) — NÃO vaza para /carreiras,
 * que mantém `styles/carreiras.css` próprio.
 *
 * Ordem: tokens/CSS Vanilla → ponte --hi-* → adaptadores React-only.
 */
@import './legado-bundle.css';
@import './hi-bridge.css';
@import './legado-react.css';
